import { SteelOrder } from "./types";
import { Header } from '../../../../components/SubHeaderFilter/types';

export const getStatusText = (status: boolean | null | undefined): string => {
  if (status === true) return 'Fechada';
  if (status === false) return 'Cancelado';
  return 'Em Aberto';
};

export const formatStatus = (status: boolean | null | undefined): { text: string; status: boolean | null | undefined } => {
  return {
    text: getStatusText(status),
    status: status
  };
};

export const formatDate = (dateString: string | undefined): string => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'N/A';
    return new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(date);
  } catch {
    return 'N/A';
  }
};

export const formatCurrency = (value: number | undefined): string => {
  if (typeof value !== 'number' || isNaN(value)) return 'N/A';
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const getOrderNumberDisplay = (order: {
  id: number;
  status?: boolean | null;
  proposalNumber?: number | null;
  saleNumber?: number | null;
}): string => {
  if (order.status === true && order.saleNumber != null) return `Venda nº ${order.saleNumber}`;
  if (order.proposalNumber != null) return `Proposta nº ${order.proposalNumber}`;
  return String(order.id);
};

export const getTotalWeight = (items: SteelOrder['items']): string => {
  if (!items || items.length === 0) return '0.00 kg';

  const totalWeight = items.reduce((sum, orderItem) => {
    const weightStr = orderItem.offeredProduct?.weigth || orderItem.requestedProduct?.weigth;
    const weight = weightStr ? parseFloat(weightStr.replace(',', '.')) : 0;
    return sum + (isNaN(weight) ? 0 : weight);
  }, 0);

  return `${totalWeight.toFixed(2)} kg`;
};

export const ORDER_FIELD_TRANSLATIONS: Record<string, { label: string; type: 'string' | 'number' | 'date' | 'boolean' | 'currency' }> = {
  id: { label: 'ID / Nº do pedido', type: 'number' },
  proposalNumber: { label: 'Nº da proposta', type: 'number' },
  saleNumber: { label: 'Nº da venda', type: 'number' },
  client: { label: 'Cliente', type: 'string' },
  clientId: { label: 'Cliente', type: 'string' },
  seller: { label: 'Vendedor', type: 'string' },
  sellerId: { label: 'Vendedor', type: 'string' },
  supplier: { label: 'Fornecedor', type: 'string' },
  supplierId: { label: 'Fornecedor', type: 'string' },
  closedByUser: { label: 'Fechado por', type: 'string' },
  closedById: { label: 'Fechado por', type: 'string' },
  contactName: { label: 'Nome do contato', type: 'string' },
  contactEmail: { label: 'E-mail do contato', type: 'string' },
  contactPhone: { label: 'Telefone do contato', type: 'string' },
  orderDate: { label: 'Data do pedido', type: 'date' },
  deliveryDate: { label: 'Previsão de entrega', type: 'date' },
  startDateOfDelivery: { label: 'Data início de entrega', type: 'date' },
  finalDateOfDelivery: { label: 'Data final de entrega', type: 'date' },
  billingDate: { label: 'Data de faturamento', type: 'date' },
  createdAt: { label: 'Data de criação', type: 'date' },
  updatedAt: { label: 'Data de atualização', type: 'date' },
  deletedAt: { label: 'Data de exclusão', type: 'date' },
  total: { label: 'Valor total', type: 'currency' },
  totalCost: { label: 'Custo total', type: 'currency' },
  sellingPrice: { label: 'Preço de venda', type: 'currency' },
  shippingValue: { label: 'Valor do frete', type: 'currency' },
  taxes: { label: 'Impostos', type: 'currency' },
  maximumBillingAmount: { label: 'Valor máx. faturamento', type: 'currency' },
  totalQuantity: { label: 'Quantidade total', type: 'number' },
  quantityItems: { label: 'Qtd. de itens', type: 'number' },
  quantityPieces: { label: 'Qtd. de peças', type: 'number' },
  deliveryBusinessDays: { label: 'Prazo entrega (dias úteis)', type: 'number' },
  deliveryTime: { label: 'Horário de entrega', type: 'string' },
  trackingCode: { label: 'Código de rastreio', type: 'string' },
  npc: { label: 'NPC', type: 'string' },
  saleNumberPloomes: { label: 'Nº venda Ploomes', type: 'number' },
  originDealIdPloomes: { label: 'ID negócio Ploomes', type: 'number' },
  clientOrderNumber: { label: 'Nº do pedido do cliente', type: 'number' },
  extraInfo: { label: 'Informação extra', type: 'string' },
  criticalAnalysis: { label: 'Análise crítica', type: 'boolean' },
  criticalAnalysisDesc: { label: 'Descrição da análise', type: 'string' },
  saleStatus: { label: 'Status da venda', type: 'string' },
  status: { label: 'Status', type: 'boolean' },
  integratedWithOmie: { label: 'Integrado Omie', type: 'boolean' },
  orderType: { label: 'Tipo do pedido', type: 'string' },
  orderTypeId: { label: 'Tipo do pedido', type: 'string' },
  representative: { label: 'Representante', type: 'string' },
  representativeId: { label: 'Representante', type: 'string' },
  orderSituation: { label: 'Situação do pedido', type: 'string' },
  orderSituationId: { label: 'Situação do pedido', type: 'string' },
  generalClass: { label: 'Classe geral', type: 'string' },
  generalClassId: { label: 'Classe geral', type: 'string' },
  shippingType: { label: 'Tipo de frete', type: 'string' },
  shippingTypeId: { label: 'Tipo de frete', type: 'string' },
  paymentCondition: { label: 'Condição de pagamento', type: 'string' },
  paymentConditionId: { label: 'Condição de pagamento', type: 'string' },
  carrier: { label: 'Transportadora', type: 'string' },
  paymentMethod: { label: 'Forma de pagamento', type: 'string' },
  installments: { label: 'Parcelas', type: 'number' },
  installmentCount: { label: 'Parcelas', type: 'number' },
  items: { label: 'Peso total', type: 'string' },
  totalWeight: { label: 'Peso total', type: 'number' },
  orderItems: { label: 'Itens do pedido', type: 'string' },
  orderItemsSummary: { label: 'Itens do pedido', type: 'string' },
  myCnpj: { label: 'Meu CNPJ', type: 'string' },
  tenantId: { label: 'Tenant ID', type: 'number' },
  contactId: { label: 'ID do contato', type: 'number' },
};

export const getOrderColumnLabel = (key: string, fallback?: string): string => {
  if (ORDER_FIELD_TRANSLATIONS[key]?.label) {
    return ORDER_FIELD_TRANSLATIONS[key].label;
  }
  if (fallback && fallback !== key) {
    return fallback;
  }
  const spaced = key.replace(/([A-Z])/g, ' $1').trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
};

export const getOrderColumnType = (key: string): 'string' | 'number' | 'date' | 'boolean' | 'currency' => {
  return ORDER_FIELD_TRANSLATIONS[key]?.type || 'string';
};

export const buildSteelOrdersTableHeaders = (
  dynamicColumns?: { key: string; label?: string; type?: string }[]
): Header[] => {
  if (!dynamicColumns || dynamicColumns.length === 0) {
    return steelOrdersTableHeaders;
  }

  return dynamicColumns
    .filter((col) => !['tenantId', 'deletedAt', 'actions'].includes(col.key))
    .map((col) => {
      const label = col.label && col.label !== col.key ? col.label : getOrderColumnLabel(col.key, col.label);
      const type = (col.type as any) || getOrderColumnType(col.key);
      return {
        key: col.key,
        label,
        type,
      };
    });
};

export const steelOrdersTableHeaders: Header[] = [
  { key: 'id', label: 'ID / Nº do pedido', type: 'number' },
  { key: 'proposalNumber', label: 'Nº da proposta', type: 'number' },
  { key: 'saleNumber', label: 'Nº da venda', type: 'number' },
  { key: 'saleNumberPloomes', label: 'Nº venda Ploomes', type: 'number' },
  { key: 'npc', label: 'NPC', type: 'string' },
  { key: 'client', label: 'Cliente', type: 'string' },
  { key: 'seller', label: 'Vendedor', type: 'string' },
  { key: 'orderDate', label: 'Data do pedido', type: 'date' },
  { key: 'deliveryDate', label: 'Previsão de entrega', type: 'date' },
  { key: 'startDateOfDelivery', label: 'Data início de entrega', type: 'date' },
  { key: 'finalDateOfDelivery', label: 'Data final de entrega', type: 'date' },
  { key: 'billingDate', label: 'Data de faturamento', type: 'date' },
  { key: 'total', label: 'Valor total', type: 'currency' },
  { key: 'totalCost', label: 'Custo total', type: 'currency' },
  { key: 'sellingPrice', label: 'Preço de venda', type: 'currency' },
  { key: 'shippingValue', label: 'Valor do frete', type: 'currency' },
  { key: 'taxes', label: 'Impostos', type: 'currency' },
  { key: 'maximumBillingAmount', label: 'Valor máx. faturamento', type: 'currency' },
  { key: 'totalQuantity', label: 'Quantidade total', type: 'number' },
  { key: 'quantityItems', label: 'Qtd. de itens', type: 'number' },
  { key: 'quantityPieces', label: 'Qtd. de peças', type: 'number' },
  { key: 'deliveryBusinessDays', label: 'Prazo entrega (dias úteis)', type: 'number' },
  { key: 'deliveryTime', label: 'Horário de entrega', type: 'string' },
  { key: 'trackingCode', label: 'Código de rastreio', type: 'string' },
  { key: 'originDealIdPloomes', label: 'ID negócio Ploomes', type: 'number' },
  { key: 'clientOrderNumber', label: 'Nº do pedido do cliente', type: 'number' },
  { key: 'extraInfo', label: 'Informação extra', type: 'string' },
  { key: 'criticalAnalysis', label: 'Análise crítica', type: 'boolean' },
  { key: 'criticalAnalysisDesc', label: 'Descrição da análise', type: 'string' },
  { key: 'saleStatus', label: 'Status da venda', type: 'string' },
  { key: 'status', label: 'Status', type: 'boolean' },
  { key: 'integratedWithOmie', label: 'Integrado Omie', type: 'boolean' },
  { key: 'orderType', label: 'Tipo do pedido', type: 'string' },
  { key: 'representative', label: 'Representante', type: 'string' },
  { key: 'orderSituation', label: 'Situação do pedido', type: 'string' },
  { key: 'generalClass', label: 'Classe geral', type: 'string' },
  { key: 'shippingType', label: 'Tipo de frete', type: 'string' },
  { key: 'paymentCondition', label: 'Condição de pagamento', type: 'string' },
  { key: 'carrier', label: 'Transportadora', type: 'string' },
  { key: 'paymentMethod', label: 'Forma de pagamento', type: 'string' },
  { key: 'installments', label: 'Parcelas', type: 'number' },
  { key: 'totalWeight', label: 'Peso total', type: 'number' },
  { key: 'orderItems', label: 'Itens do pedido', type: 'string' },
  { key: 'myCnpj', label: 'Meu CNPJ', type: 'string' },
  { key: 'contactName', label: 'Nome do contato', type: 'string' },
  { key: 'contactEmail', label: 'E-mail do contato', type: 'string' },
  { key: 'contactPhone', label: 'Telefone do contato', type: 'string' },
];